// extracted by mini-css-extract-plugin
module.exports = {"notice":"DisallowedPermsNotice_notice__1mIHa","perms":"DisallowedPermsNotice_perms__vqM3h"};